<template>
  <v-dialog
    v-model="expanded"
    width="1226"
    content-class="reply-dialog"
    @click:outside="closeDialog"
    v-track="'reply-ticket-dialog'"
  >
    <v-card class="expanded-reply-box">
      <reply-editor
        :ticketData="ticketData"
        :commentType="commentType"
        :supportEmailList="supportEmailList"
        :lastCommentData="lastCommentData"
      />
      <v-card-actions class="card-actions">
        <v-spacer></v-spacer>
        <v-btn outlined class="font-weight-bold" v-track="'cancel-btn-click-on-reply-section'" @click="cancelReply">
          Cancel
        </v-btn>
        <v-btn
          class="font-weight-bold"
          @click="sendReply('', '', 'expanded')"
          v-if="commentType === 'forward' || commentType === 'forward_ticket' || commentType === 'thread_reply'"
          dark
          v-track="'send-forward-btn-click'"
        >
          <span class="white--text">
            Send
          </span>
        </v-btn>
        <v-btn-toggle
          v-else
          dense
          class="ml-2"
          :dark="!disableSendButton"
          :class="disableSendButton ? 'disable-events' : ''"
        >
          <v-btn class="font-weight-bold" @click="sendReply('', '', 'expanded')" v-track="'send-reply-btn-click'">
            <span class="white--text">
              Send
            </span>
          </v-btn>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn min-width="30px" :disabled="editorHTML ? false : true">
                <span v-bind="attrs" v-on="on" class="black--text float-left">
                  <v-icon v-if="attrs['aria-expanded'] == 'false'">
                    mdi-menu-down
                  </v-icon>
                  <v-icon v-if="attrs['aria-expanded'] == 'true'">
                    mdi-menu-up
                  </v-icon>
                </span>
              </v-btn>
            </template>
            <v-list>
              <v-list-item-group>
                <v-list-item
                  class="cursor-pointer"
                  v-track="'send-reply-with-status'"
                  v-for="(item, index) in filteredSendStatusList"
                  :key="index"
                  @click="sendReply('status', item, 'expanded')"
                >
                  <v-list-item-title> {{ item.name }} </v-list-item-title>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
        </v-btn-toggle>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  name: "ReplyDialog",
  components: {
    ReplyEditor: () => import('./ReplyEditor'),
  },
  props: {
    ticketData: {
      type: [Object, Array],
      required: true
    },
    commentType:{
      type: [String],
      default: 'forward'
    },
    supportEmailList:{
      type: [Object, Array],
      default: ()=> ([])
    }, 
    disableSendButton:{
      type: Boolean,
      default: false
    }, 
    editorHTML:{
      type: String,
      default: '',
    },
    lastCommentData:{
      type: [Object, Array],
      required: false,
    },
    filteredSendStatusList:{
      type: [Object, Array],
      required: false,
    },
  },
  data() {
    return {
      expanded: false
    }
  },
  watch: {
    replyExpanded(value) {
      if (!value)
        this.expanded = false
    }
  },
  computed: {
    replyExpanded() {
      return this.$store.getters["reply/replyExpanded"];
    }
  },
  methods: {
    ...mapMutations({
      setReplyExpanded: "reply/setReplyExpanded"
    }),
    cancelReply() {
      this.$emit('cancel-reply')
    },
    sendReply(action, item, type) {
      this.$emit('send-reply', action, item, type)
    },
    closeDialog() {
      this.setReplyExpanded(false)
    }
  }
}  
</script>
